import { render, staticRenderFns } from "./large-payout-approval.vue?vue&type=template&id=63db17b0&scoped=true"
import script from "./large-payout-approval.vue?vue&type=script&lang=js"
export * from "./large-payout-approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db17b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63db17b0')) {
      api.createRecord('63db17b0', component.options)
    } else {
      api.reload('63db17b0', component.options)
    }
    module.hot.accept("./large-payout-approval.vue?vue&type=template&id=63db17b0&scoped=true", function () {
      api.rerender('63db17b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/online-transaction/large-payout-approval.vue"
export default component.exports